import axios from '@/core/axios';

import { Statement, ItemType, StatementType } from './statements.types';

export class StatementsService {
  all(model): Promise<Statement> {
    return axios.get(`/statements/all/${model}`).then(resp => resp.data);
  }

  getFirstLevel(statementType: StatementType, itemType: ItemType): Promise<Statement> {
    return axios.get(`/statements/first_level/${statementType}/${itemType}`).then(resp => resp.data);
  }

  getChilds(statementId: number): Promise<Statement[]> {
    if (!statementId) throw new Error('Missing statement id in getChilds');
    return axios.get<Statement[]>(`/statements/${statementId}/get_childs`).then(resp => resp.data);
  }

  getStatementById(statementId: number): Promise<Statement> {
    if (!statementId) throw new Error('Missing statement_id in getStatementById');
    return axios.get<Statement>(`/statements/${statementId}/get_statement_by_id`).then(resp => resp.data);
  }

  getNextStatement(statementId: number): Promise<Statement> {
    if (!statementId) throw new Error('Missing statement_id in getNextStatement');
    return axios.get<Statement>(`/statements/${statementId}/next_statement`).then(resp => resp?.data);
  }

  getParsedName(statementId: number): Promise<Statement> {
    if (!statementId) throw new Error('Missing statementId in getParsedName');
    return axios.get<Statement>(`/statements/${statementId}/get_parsed_name`).then(resp => resp?.data);
  }

  update(statement_id: number, statement: Statement): Promise<Statement> {
    return axios.put(`/statements/${statement_id}`, statement).then(resp => resp.data);
  }
}

export const statementsService = new StatementsService();
